import type React from "react";
import {
  type WorkflowStepUserResponse,
  WorkflowStepUserResponses,
} from "~/api/types";
import { cn } from "~/lib/utils";
import { Badge } from "~/atoms/badge";
import { ActionIndicator } from "./StepUserActionIndicator";

interface WorkflowStepBadgeProps {
  response: WorkflowStepUserResponse;
  isActive: boolean;
  isCurrentUser: boolean;
  additionalClasses?: string;
  children: React.ReactNode;
}

export function WorkflowStepBadge({
  response,
  isActive,
  isCurrentUser,
  additionalClasses,
  children,
}: WorkflowStepBadgeProps) {
  const badgeClassName = cn(
    "flex items-center gap-2 text-xs",
    {
      "border-amber-200 bg-amber-50":
        isCurrentUser &&
        isActive &&
        response === WorkflowStepUserResponses.pending,
      "border-red-200 bg-red-50":
        response === WorkflowStepUserResponses.rejected,
      "border-green-200 bg-green-50":
        response === WorkflowStepUserResponses.approved,
    },
    additionalClasses,
  );

  return (
    <Badge variant="secondary" className={badgeClassName}>
      {children}
      <ActionIndicator response={response} />
    </Badge>
  );
}
